(function () {
  const PANEL_SELECTOR = '[data-product-info-panel]';

  function setOpen(item, open) {
    const trigger = item.querySelector('.product-info-panel__trigger');
    const panel = item.querySelector('.product-info-panel__panel');
    if (!trigger || !panel) return;

    item.classList.toggle('is-open', open);
    trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
    if (open) {
      panel.removeAttribute('hidden');
    } else {
      panel.setAttribute('hidden', '');
    }
  }

  function initPanel(root) {
    if (!root || root.hasAttribute('data-info-panel-ready')) return;
    root.setAttribute('data-info-panel-ready', 'true');

    root.querySelectorAll('.product-info-panel__trigger').forEach((btn) => {
      btn.addEventListener('click', () => {
        const item = btn.closest('.product-info-panel__item');
        if (!item) return;
        const willOpen = !item.classList.contains('is-open');

        root.querySelectorAll('.product-info-panel__item').forEach((el) => {
          setOpen(el, false);
        });

        if (willOpen) setOpen(item, true);
      });
    });
  }

  function initAll() {
    document.querySelectorAll(PANEL_SELECTOR).forEach(initPanel);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', initAll);
})();
